import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';

import { LayoutContainer } from 'components/layout/styled';
import { t } from 'state/intl/translations';
import { theme } from 'styles/configure-theme';
import { routes } from 'utils/routing';

import { iconVariant } from '../constants';

import {
  BackArrowContainer,
  SignUpHeader,
  SignUpHeaderContainer,
} from './signup-mobile-header.styled';

// The types for react native do not support `dataSet` yet, but
// it is the required way to pass data-* attributes to the node.
// And we are using this mechanism to ensure these nodes are rendered
// during the pre-render, but only visible for the correct screen size.
const onlyRenderInMobile = () =>
  ({
    dataSet: { mediaquery: 'mobile' },
  } as any);

const SignupMobileHeader = () => {
  const { back, canGoBack, replace } = useRouter();

  const handleGoBack = () => {
    canGoBack() ? back() : replace(routes.base);
  };

  return (
    <SignUpHeaderContainer {...onlyRenderInMobile()} testID="signup-mobile-header">
      <LayoutContainer>
        <SignUpHeader>
          <BackArrowContainer testID="mobile-nav-go-back" onPress={handleGoBack}>
            <Icon
              variant={iconVariant}
              color={theme.token('icon-default')}
              width="24px"
              title={t('back')}
            />
          </BackArrowContainer>
        </SignUpHeader>
      </LayoutContainer>
    </SignUpHeaderContainer>
  );
};

export default SignupMobileHeader;
